<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import { getAction, postAction } from '@/command/netTool'
import Naves from '@/views/com/Naves'
import apiTool from '@/command/apiTool'
import { Modal } from 'ant-design-vue'
import moment from 'moment'
export default {
  name: 'mainBackDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: {},
      showAppModel: false,
    }
  },
  mounted() {
    const { id } = this.$route.query
    if (id) {
      getAction('/farmHotZoneConfig/detail?id=' + id).then((res) => {
        this.detail = res.data
      })
    }
    this.getMessage()
  },
  methods: {
    getMessage() {
      window.addEventListener('message', (event) => {
        if (event.data.type === 'GO_BACK') {
          // 执行返回逻辑
          this.showAppModel = false
        }
        if (event.data.type === 'SAVE_BACK') {
          this.detail.jsonText = event.data.data
          this.showAppModel = false
          console.log(this.detail, ' this.detail')
        }
      })
    },
    handleSendMessage() {
      const iframe = this.$refs.iframe
      const message = {
        ...this.detail,
        appJson: this.detail.jsonText,
      }
      iframe.contentWindow.postMessage(message, '*') // 发送消息
    },
    getForm1() {
      return [
        {
          name: '活动名称',
          key: 'name',
          labelAlign: 'right',
          type: 'input',
          cols: 12,
          rules: [
            {
              required: true,
              type: 'string',
            },
          ],
        },
        {
          name: '活动时间',
          type: 'rangePicker',
          keys: ['startTime', 'endTime'],
          cols: 12,
          rules: [
            {
              required: true,
            },
          ],
        },
        {
          name: '图片',
          key: 'imgUrl',
          type: 'upload',
          maxLength: 1,
          cols: 24,
          rules: [
            {
              required: true,
              message: '请上传图片',
              type: 'string',
            },
          ],
        },
      ]
    },

    getFoot() {
      const that = this
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: (data) => {
            const success = () => {
              this.$router.back()
            }
            if (!data.startTime || !data.endTime) {
              this.$Message.error('请选择活动时间')
              return
            }

            api.command[data.id ? 'edit' : 'create']
              .call(that, {
                url: `/farmHotZoneConfig/${data.id ? 'update' : 'save'}`,
                isPost: false,
                params: {
                  ...data,
                  upDown: '0',
                  startTime: data.startTime ? moment(data.startTime, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss') : '',
                  endTime: data.endTime ? moment(data.endTime, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss') : '',
                },
              })
              .then(success)
          },
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => {
            this.$router.back()
          },
        },
      ].filter((e) => e.display || e.display == undefined)
      return {
        left,
      }
    },
    renderAppModel() {
      return (
        <div
          class="AppModel"
          style={{
            display: this.showAppModel ? 'block' : 'none',
          }}
        >
          <iframe
            ref="iframe"
            frameborder="0"
            scrolling="auto"
            src={`${apiTool.getSzncH5Url()}/diyIndex`}
            width="100%"
            height="100%"
          ></iframe>
        </div>
      )
    },
  },
  render() {
    return (
      <div>
        <Naves
          navData={['基础设置', '页面配置']}
          onActive={(index) => {
            if (index === 1) {
              this.handleSendMessage()
              this.showAppModel = true
            }
          }}
          activeCurrentKey={this.activeKey}
        />
        <DetailFormGroup
          foot={this.getFoot()}
          form={this.detail}
          data={[{ type: 'cardForm', data: this.getForm1(), layout: 'horizontal' }]}
        />
        {this.renderAppModel()}
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
.AppModel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 999;
}
</style>
